import React from 'react';
import { FiX } from 'react-icons/fi';
import ModalPortal, { MODAL_Z } from './ModalPortal';

const ModalCustom = ({ isShow, setIsShow, content }) => {
  const close = () => setIsShow(false);

  return (
    <ModalPortal isOpen={isShow} onClose={close}>
      <div className={`fixed inset-0 ${MODAL_Z} flex items-center justify-center overflow-y-auto p-4`}>
        <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" onClick={close} aria-hidden="true" />

        <div role="dialog" aria-modal="true" className="relative max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl">
          <div className="flex justify-end">
            <button
              type="button"
              className="rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
              onClick={close}
              aria-label="Close Modal"
            >
              <FiX className="h-4 w-4" />
            </button>
          </div>
          <div>{content}</div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ModalCustom;
